import React from 'react';
import { Textarea as BaseTextarea } from 'flowbite-react';
import { ChangeEventHandler, FocusEventHandler } from 'react';
import classnames from 'classnames';
import { defaultTextAreaTheme } from './theme';
import { LabelInput } from 'modules/v2/common/AtomicDesign/atoms';

type TextAreaProps = {
  onChange?: ChangeEventHandler<HTMLTextAreaElement>;
  onBlur?: FocusEventHandler<HTMLTextAreaElement>;
  value?: string;
  disabled?: boolean;
  className?: string;
  errorMessage?: string;
  color?: 'gray' | 'failure';
  title: string;
  isValid?: boolean;
  id?: string;
  name?: string;
  placeholder?: string;
  rows?: number;
  maxLength?: number;
  showCharacterCount?: boolean;
};

const TextArea = ({
  onChange,
  onBlur,
  value = '',
  errorMessage = 'Invalid input',
  disabled,
  className,
  color = 'gray',
  title,
  isValid,
  id,
  name,
  placeholder,
  rows = 3,
  maxLength,
  showCharacterCount = false,
  ...props
}: TextAreaProps) => {
  const currentLength = value.length;
  const isOverLimit = maxLength && currentLength > maxLength;

  return (
    <>
      <div className="flex justify-between">
        <LabelInput required>
          Your custom Call to Action text
        </LabelInput>
        <div className="flex justify-end mt-1">
          <div className={classnames(
            'text-sm font-medium',
            isOverLimit ? 'text-red-500' : 'text-neutral-400'
          )}>
            {currentLength}/{maxLength} characters
          </div>
        </div>
      </div>
      <BaseTextarea
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        theme={defaultTextAreaTheme}
        color={isOverLimit ? 'failure' : color}
        className={classnames(className)}
        id={id}
        name={name}
        placeholder={placeholder}
        disabled={disabled}
        rows={rows}
        {...props}
      />
      {isOverLimit && (
        <div className="text-red-500 text-sm mt-1">
          Your custom call-to-action cannot exceed {maxLength} characters
        </div>
      )}
      {isValid === false && <span className="text-error-500 text-sm">{errorMessage}</span>}
    </>
  );
};

export default TextArea;
